import styled from 'styled-components';

type IconSVGProps = {
  clickable?: boolean;
}

export const IconSVG = styled.svg<IconSVGProps>`
  cursor     : ${props => props.clickable ? 'pointer' : 'inherit'};
  user-select: none;
`;